export default "__VITE_ASSET__fb08eb57__"